export var useAuthPanelStore = defineStore({
  id: 'authPanel',
  state: function state() {
    return {
      state: 'login',
      direction: 'left'
    };
  }
});